// tableModel = {
//     name:String,
//     key:Array,
//     perPage:Number
// }


export default{
    namespaced: true,
    state:{
        tables:[],
    },
    mutations:{
        addTable(state,table){
            let t = state.tables.find(t=> t.name == table.name)
            if(!t) state.tables.push(table)
        },
        updateTableField(state,data){
            const table = state.tables.find(t=>t.name == data.name)
            if(table) table[data.field] = data.value
        },
    },
    getters:{},
    setters:{}
}